import Headroom from "headroom.js";
import EventEmitter from "EventEmitter";

const emitter = new EventEmitter();

const toggle = document.querySelector(".js-menu-toggle");
const body = document.querySelector("body");
const menu = document.querySelector(".js-menu");
const contactToggle = document.querySelector('.js-contact-sidebar');
const logo = document.querySelector('.logo');

function registerTogglerHandlers() {
    toggle.addEventListener("click", toggleMenu);
}

function registerHeadroom() {
    const headroom = new Headroom(document.querySelector(".navbar__top"), {
        classes: {
            initial: "navbar",
            pinned: "navbar--pinned",
            unpinned: "navbar--unpinned",
            top: "navbar--top",
            notTop: "navbar--not-top",
            bottom: "navbar--bottom",
            notBottom: "navbar--not-bottom"
        },
    });

    headroom.init();
}

function toggleMenu() {
    if (toggle.classList.contains("menu-toggle--is-open")) {
        closeMenu();
    } else {
        openMenu();
    }
}

function closeMenu() {
    body.classList.remove("scrollock");
    menu.classList.remove("navbar__menu--is-open");
    toggle.classList.remove("menu-toggle--is-open");
    logo.classList.remove('u-logo-white');
    emitter.emit("close");
}

function openMenu() {
    body.classList.add("scrollock");
    menu.classList.add("navbar__menu--is-open");
    toggle.classList.add("menu-toggle--is-open");
    logo.classList.add('u-logo-white');
    emitter.emit("open");
}

document.addEventListener('keydown', e => {
    if (e.key === "Escape") {
        closeMenu()
    }
});

export default {
    init: () => {
        registerTogglerHandlers();
        registerHeadroom()
    },
    on: (event, callback) => {
        emitter.on(event, callback);
    },
    off: (event, callback) => {
        emitter.off(event, callback);
    },
};